import React, { useEffect, useState } from 'react';
import { navigate, Link } from 'gatsby';
import { Cookies } from 'react-cookie-consent';
import dataLayer from './DataLayer';
import Toggle from './Toggle';
import flagService from '../services/FlagService';
import Tooltip from './Tooltip';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { ContactCookie } from '../data/Cookies';
const ContactForm = ({
  addressSearched,
  selectedAddress,
  showInBuild,
  oneTouchSwitch,
  setOneTouchSwitch,
  selectedPlan,
  isSalesJourney,
}) => {
  const [textarea, setTextarea] = useState();
  const [contractEndDate, setContractEndDate] = useState();
  const [navigateRi, setNavigateRi] = useState();
  const [timeToContractEnd, setTimeToContractEnd] = useState();
  const [isToggled, setIsToggled] = useState();
  useEffect(() => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();

    setTimeToContractEnd(
      (contractEndDate?.getFullYear() - currentYear) * 12 +
        (contractEndDate?.getMonth() - currentMonth),
    );
    !isToggled && setTimeToContractEnd(undefined);
    isToggled && setOneTouchSwitch(false);
  }, [contractEndDate, isToggled]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const formDataObject = {};
    for (const input of event.target) {
      if (input.type === 'checkbox') formDataObject[input.name] = input.checked;
      else formDataObject[input.name] = input.value;
    }

    typeof window !== 'undefined' && window.scrollTo(0, 0);
    Cookies.set(ContactCookie, formDataObject);

    if (selectedAddress?.orderable) {
      dataLayer({
        event: 'contact_is_orderable',
      });
      selectedPlan.productCode.includes('1000-') &&
        dataLayer({
          event: 'Lit-1000-Basket-Add',
        });
      selectedPlan.productCode.includes('500-') &&
        dataLayer({
          event: 'Lit-500-Basket-Add',
        });
      selectedPlan.productCode.includes('100-') &&
        dataLayer({
          event: 'Lit-100-Basket-Add',
        });
      timeToContractEnd > 0 &&
        dataLayer({
          event: `contract-renewal-within-${timeToContractEnd}-months`,
        });
    } else if (showInBuild) {
      dataLayer({
        event: 'contact_is_not_orderable_in_CRFS_town',
      });
    } else if (!showInBuild) {
      dataLayer({
        event: 'contact_in_non_orderable_town',
      });
    }

    if (!oneTouchSwitch) {
      if (navigateRi) {
        navigate(
          !isSalesJourney
            ? '/get-lit/register-interest'
            : '/internal/sales/register-interest',
          {
            state: {
              address: selectedAddress,
              inBuildTown: selectedAddress.postalTown,
              isContactForm: true,
              inContract: isToggled,
            },
          },
        );
      } else if (selectedAddress?.orderable && !navigateRi) {
        navigate(
          !isSalesJourney ? '/secure-order/new/' : '/internal/sales/order/new',
          {
            state: {
              address: selectedAddress,
            },
          },
        );
      }
    } else {
      navigate(
        !isSalesJourney
          ? '/secure-order/one-touch-switch-page/'
          : '/internal/sales/order/one-touch-switch/',
        {
          state: {
            address: selectedAddress,
          },
        },
      );
    }
  };
  const inContractandThreeMonths = timeToContractEnd > 3 || isToggled;

  const threeMonthsText = (
    <div className="in-contract-text">
      <input
        type="submit"
        onClick={() => setNavigateRi(true)}
        className="button orderButton"
        value={'Register your interest'}
        id="continueButton"
      />
      {selectedAddress?.orderable && (
        <>
          {' '}
          <p>
            If you are still in contract and wish to purchase please checkout{' '}
            <input
              type="submit"
              className="form-button"
              value={'here'}
              id="continueButton"
            />
          </p>
          <p>
            You can call our customer service team on{' '}
            <a href="tel:03304604610" className="form-button">
              03304604610
            </a>
          </p>
        </>
      )}
    </div>
  );

  return (
    <form onSubmit={handleSubmit} action="#">
      <div className="form-input-container">
        <div className="form-input-inner column-1">
          <label htmlFor="firstName">
            First name<i>*</i>
          </label>
          <input type="text" name="firstName" required />
        </div>
        <div className="form-input-inner column-3">
          <label htmlFor="lastName">
            Last name<i>*</i>
          </label>
          <input type="text" name="lastName" required />
        </div>
        <div className="form-input-inner column-1">
          <label htmlFor="email">
            Email<i>*</i>
          </label>
          <input required type="email" name="email" />
        </div>
        <div className="form-input-inner column-3">
          <label htmlFor="phoneNumber">
            Phone number<i>*</i>
          </label>
          <input required type="tel" name="phoneNumber" />
        </div>{' '}
        {selectedAddress?.orderable && (
          <Toggle
            offToggledValue={'Still in contract?'}
            onToggledValue={'Still in contract?'}
            isToggled={isToggled}
            setIsToggled={setIsToggled}
          />
        )}
        <></>
        {isToggled && (
          <>
            <div className="form-input-inner column-1">
              <label htmlFor="contractEndDate">Contract End Date</label>
              <input
                type="month"
                name="contractEndDate"
                onChange={(e) => setContractEndDate(new Date(e.target.value))}
              />
            </div>{' '}
            <div className="form-input-inner column-3">
              <label>Current Provider</label>
              <select title="Current Provider" name="currentProvider">
                <option value="">I don’t have a provider</option>
                <option value="BT">BT</option>
                <option value="Sky">Sky</option>
                <option value="Virgin">Virgin</option>
                <option value="TalkTalk">TalkTalk</option>
                <option value="EE">EE</option>
                <option value="Plusnet">Plusnet</option>
                <option value="Post Office">Post Office</option>
                <option value="Pop Telecom">Pop Telecom</option>
                <option value="Vodafone">Vodafone</option>
                <option value="My provider is not listed">
                  My provider is not listed
                </option>
              </select>
            </div>
            <div className="form-input-inner column-1">
              <label>How did you hear about us?</label>
              <select
                name="hearAboutUs"
                onChange={(event) => {
                  setTextarea(event.target.value);
                }}
              >
                <option value="">--None--</option>
                <option value="Petrol pump">Petrol pump</option>
                <option value="Roundabout">Roundabout</option>
                <option value="Supermarket">Supermarket</option>
                <option value="TV advert">TV advert</option>
                <option value="Leaflet or Flyer through the post">
                  Leaflet or Flyer through the post
                </option>
                <option value="Email">Email</option>
                <option value="Social Media (Facebook, Twitter, etc)">
                  Social Media (Facebook, Twitter, etc)
                </option>
                <option value="Search Engine (Google, Bing, etc)">
                  Search Engine (Google, Bing, etc)
                </option>
                <option value="Local event">Local event</option>
                <option value="Football club">Football club</option>
                <option value="Recommendation">Recommendation</option>
                <option value="Lit Fibre representative at my door">
                  Lit Fibre Representative at my door
                </option>
                <option value="Lit Fibre engineer">Lit Fibre engineer</option>
                <option value="Customer reviews e.g. Trustpilot">
                  Customer reviews e.g. Trustpilot
                </option>
                <option value="Comparison website">Comparison website</option>
                <option value="Radio advert">Radio advert</option>
                <option value="News">News</option>
                <option value="Northgate School - Bishops Stortford">
                  Northgate School - Bishops Stortford
                </option>
                <option value="Other">Other</option>
              </select>
            </div>
            {textarea === 'Other' && (
              <div className="form-input-inner column-3">
                <label>Other - Please specify:</label>
                <textarea maxLength={20} rows="3" wrap="soft"></textarea>
              </div>
            )}{' '}
            <div className="form-checkbox-container column-span">
              <input type="checkbox" name="Marketing" className="checkbox" />
              <p>
                By ticking the box I consent to Lit Fibre processing and storing
                this information in accordance with its Privacy Policy and using
                these details to send me information about Lit Fibre's services.
                I understand that I may change my mind and unsubscribe at any
                time. Your contact details will be used for keeping them up to
                date with our progress and we will not be shared with third
                parties.
              </p>{' '}
            </div>
            <p>Contact Preferences</p>
            <div className="form-checkbox-container column-1">
              <input type="checkbox" name="contactEmail" className="checkbox" />
              <label htmlFor="contactEmail">E-mail</label>
            </div>
            <div className="form-checkbox-container column-1">
              <input type="checkbox" name="contactPhone" className="checkbox" />
              <label htmlFor="contactPhone">Phone</label>
            </div>
            <div className="form-checkbox-container column-1">
              <input type="checkbox" name="contactMail" className="checkbox" />
              <label htmlFor="contactMail">Mail</label>
            </div>
          </>
        )}{' '}
        {selectedAddress.orderable &&
          flagService.OneTouchSwitch &&
          !isToggled && (
            <div className="form-checkbox-container column-span">
              <input
                className="checkbox"
                type="checkbox"
                name="oneTouchSwitch"
                value={oneTouchSwitch}
                onChange={(event) => setOneTouchSwitch(event.target.checked)}
              />
              <p style={{ display: 'flex', alignItems: 'center' }}>
                I would like to switch my broadband via One Touch Switch{' '}
                <Tooltip
                  id="otsTip"
                  color="#000"
                  place="top"
                  content={`One Touch Switch makes switching providers easy. All you have to do is enter your details and read over your Impact report sent to you via email. If you agree to the switch, sit back and let your new and old provider do the work. No more awkward phone calls! `}
                  className={'orderJourneyTooltip'}
                  icon={faCircleInfo}
                />
              </p>
            </div>
          )}
      </div>

      {addressSearched && (
        <div className="order-card-button-container">
          {/* <Link to="/" onClick={clearCookies}>
            <button className="button orderButton">Back</button>
          </Link> */}
          {oneTouchSwitch && !isToggled && (
            <input
              type="submit"
              className="orderButton button"
              value="One touch switch"
            />
          )}
          {!inContractandThreeMonths && !isToggled && !oneTouchSwitch && (
            <input
              type="submit"
              className="button orderButton"
              onClick={() => !selectedAddress.orderable && setNavigateRi(true)}
              value={
                selectedAddress?.orderable
                  ? 'Continue!'
                  : 'Register your interest'
              }
              id="continueButton"
            />
          )}{' '}
          {selectedAddress?.orderable &&
            !inContractandThreeMonths &&
            !oneTouchSwitch &&
            !isToggled && (
              <input
                type="submit"
                className="form-button"
                onClick={() => setNavigateRi(true)}
                value="Register your interest"
              />
            )}
          {inContractandThreeMonths && threeMonthsText}
        </div>
      )}
    </form>
  );
};

export default ContactForm;
